import { getToken, getTokenHeader } from '../../../screen/auth/action';
import { axios } from '../../../utils/settings';
import { getSearchProductsUrl } from '../url';

export const searchProducts = async (queryData, queryParams) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(`${getSearchProductsUrl()}`, queryData, {
        params: queryParams,
        ...getTokenHeader(token),
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const fetchSkuFilterAction = async (searchIndex, queryData) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(
        `${getSearchProductsUrl()}?search_index=${searchIndex}&filter=true`,
        queryData,
        { ...getTokenHeader(token) },
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
